
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";



export const exhibition = {


    
    name(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "name");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "Exhibition";
            case "de": return "Ausstellung";
            default: return `[name: ${language} missing]`;
        }
    
    },
            

    
    description(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "description");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        return "Get started by learning more about the exhibition.";
    },
            
};
